/** Constantes fiscais compartilhadas (grupo tributário, NF-e, etc.). */

export const CFOP_LIST = [
  { value: '5101', label: '5101 - Venda de produção do estabelecimento' },
  { value: '5102', label: '5102 - Venda de mercadoria adquirida/recebida de terceiros' },
  { value: '5403', label: '5403 - Venda mercadoria adquirida – ST' },
  { value: '5405', label: '5405 - Venda de mercadoria de terceiros – ST' },
  { value: '5103', label: '5103 - Venda de produção a não contribuinte' },
  { value: '6102', label: '6102 - Venda de mercadoria adquirida de terceiros (interestadual)' },
];

export const CST_ICMS_CSOSN = [
  { value: 0, label: '00 - Tributada integralmente' },
  { value: 10, label: '10 - Tributada e com cobrança do ICMS por ST' },
  { value: 20, label: '20 - Com redução da base de cálculo' },
  { value: 30, label: '30 - Isenta ou não tributada e com cobrança por ST' },
  { value: 40, label: '40 - Isenta' },
  { value: 41, label: '41 - Não tributada' },
  { value: 50, label: '50 - Suspensão' },
  { value: 51, label: '51 - Diferimento' },
  { value: 60, label: '60 - ICMS cobrado anteriormente por ST' },
  { value: 61, label: '61 - Tributação monofásica sobre combustíveis cobrada anteriormente' },
  { value: 70, label: '70 - Redução base e cobrança por ST' },
  { value: 90, label: '90 - Outros' },
  { value: 101, label: '101 - Tributada pelo Simples Nacional com permissão de crédito' },
  { value: 102, label: '102 - Tributada pelo Simples Nacional sem permissão de crédito' },
  { value: 103, label: '103 - Isenção do ICMS no Simples Nacional para faixa de receita' },
  { value: 201, label: '201 - Tributada SN com permissão de crédito e com ST' },
  { value: 202, label: '202 - Tributada SN sem permissão de crédito e com ST' },
  { value: 203, label: '203 - Isenção SN para faixa de receita e com ST' },
  { value: 300, label: '300 - Imune' },
  { value: 400, label: '400 - Não tributada pelo Simples Nacional' },
  { value: 500, label: '500 - ICMS cobrado anteriormente por ST (SN)' },
  { value: 900, label: '900 - Outros (SN)' },
];

/** CST ICMS — regime normal (Lucro Real/Presumido). */
export const CST_ICMS_LR = [
  { value: 0, label: '00 — Tributada integralmente' },
  { value: 10, label: '10 — Tributada e com cobrança do ICMS por ST' },
  { value: 20, label: '20 — Com redução da base de cálculo' },
  { value: 30, label: '30 — Isenta ou não tributada e com cobrança por ST' },
  { value: 40, label: '40 — Isenta' },
  { value: 41, label: '41 — Não tributada' },
  { value: 50, label: '50 — Suspensão' },
  { value: 51, label: '51 — Diferimento' },
  { value: 60, label: '60 — ICMS cobrado anteriormente por ST' },
  { value: 61, label: '61 — Monofásico combustíveis (cobrado anteriormente)' },
  { value: 70, label: '70 — Redução de BC e cobrança por ST' },
  { value: 90, label: '90 — Outros' },
];

/** CSOSN — Simples Nacional. */
export const CST_ICMS_SN = CST_ICMS_CSOSN.filter((o) => o.value >= 100);

/** True quando o código é CST (regime normal), não CSOSN. */
export function isCstIcmsRegimeNormal(code) {
  const n = Number(String(code ?? '').replace(/\D/g, ''));
  return Number.isFinite(n) && n <= 90;
}

export const IPI_CST = [
  { value: 0, label: '00 - Entrada com recuperação de crédito' },
  { value: 1, label: '01 - Entrada tributada com alíquota zero' },
  { value: 2, label: '02 - Entrada isenta' },
  { value: 3, label: '03 - Entrada não tributada' },
  { value: 4, label: '04 - Entrada imune' },
  { value: 5, label: '05 - Entrada com suspensão' },
  { value: 49, label: '49 - Outras entradas' },
  { value: 50, label: '50 - Saída tributada' },
  { value: 51, label: '51 - Saída tributada com alíquota zero' },
  { value: 52, label: '52 - Saída isenta' },
  { value: 53, label: '53 - Saída não tributada' },
  { value: 54, label: '54 - Saída imune' },
  { value: 55, label: '55 - Saída com suspensão' },
  { value: 99, label: '99 - Outras saídas' },
];

export const PIS_COFINS_CST = [
  { value: 1, label: '01 - Operação tributável (alíquota básica)' },
  { value: 2, label: '02 - Operação tributável (alíquota diferenciada)' },
  { value: 3, label: '03 - Operação tributável (monofásica – alíquota zero)' },
  { value: 4, label: '04 - Operação tributável (alíquota zero)' },
  { value: 6, label: '06 - Operação tributável (alíquota por unidade de produto)' },
  { value: 7, label: '07 - Operação isenta da contribuição' },
  { value: 8, label: '08 - Operação sem incidência da contribuição' },
  { value: 9, label: '09 - Operação com suspensão da contribuição' },
  { value: 49, label: '49 - Outras operações de saída' },
  { value: 99, label: '99 - Outras operações' },
];

export const ORIGEM_MERCADORIA = [
  { value: 0, label: '0 - Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8' },
  { value: 1, label: '1 - Estrangeira - importação direta' },
  { value: 2, label: '2 - Estrangeira - adquirida no mercado interno' },
  { value: 3, label: '3 - Nacional c/ conteúdo de importação > 40%' },
  { value: 4, label: '4 - Nacional c/ processo produtivo básico' },
  { value: 5, label: '5 - Nacional c/ conteúdo de importação ≤ 40%' },
  { value: 6, label: '6 - Estrangeira - importação direta sem similar (CAMEX)' },
  { value: 7, label: '7 - Estrangeira - adquirida interno sem similar (CAMEX)' },
  { value: 8, label: '8 - Nacional mercadoria ou bem importado' },
];

/** UFs brasileiras com alíquota interestadual padrão (Convênio ICMS — destino). */
export const UFS_BR = [
  { sigla: 'AC', nome: 'Acre', aliquotaInterestadual: 7 },
  { sigla: 'AL', nome: 'Alagoas', aliquotaInterestadual: 7 },
  { sigla: 'AP', nome: 'Amapá', aliquotaInterestadual: 7 },
  { sigla: 'AM', nome: 'Amazonas', aliquotaInterestadual: 7 },
  { sigla: 'BA', nome: 'Bahia', aliquotaInterestadual: 7 },
  { sigla: 'CE', nome: 'Ceará', aliquotaInterestadual: 7 },
  { sigla: 'DF', nome: 'Distrito Federal', aliquotaInterestadual: 7 },
  { sigla: 'ES', nome: 'Espírito Santo', aliquotaInterestadual: 7 },
  { sigla: 'GO', nome: 'Goiás', aliquotaInterestadual: 7 },
  { sigla: 'MA', nome: 'Maranhão', aliquotaInterestadual: 7 },
  { sigla: 'MT', nome: 'Mato Grosso', aliquotaInterestadual: 7 },
  { sigla: 'MS', nome: 'Mato Grosso do Sul', aliquotaInterestadual: 7 },
  { sigla: 'PA', nome: 'Pará', aliquotaInterestadual: 7 },
  { sigla: 'PB', nome: 'Paraíba', aliquotaInterestadual: 7 },
  { sigla: 'PE', nome: 'Pernambuco', aliquotaInterestadual: 7 },
  { sigla: 'PI', nome: 'Piauí', aliquotaInterestadual: 7 },
  { sigla: 'RN', nome: 'Rio Grande do Norte', aliquotaInterestadual: 7 },
  { sigla: 'RO', nome: 'Rondônia', aliquotaInterestadual: 7 },
  { sigla: 'RR', nome: 'Roraima', aliquotaInterestadual: 7 },
  { sigla: 'SE', nome: 'Sergipe', aliquotaInterestadual: 7 },
  { sigla: 'TO', nome: 'Tocantins', aliquotaInterestadual: 7 },
  { sigla: 'MG', nome: 'Minas Gerais', aliquotaInterestadual: 12 },
  { sigla: 'PR', nome: 'Paraná', aliquotaInterestadual: 12 },
  { sigla: 'RJ', nome: 'Rio de Janeiro', aliquotaInterestadual: 12 },
  { sigla: 'RS', nome: 'Rio Grande do Sul', aliquotaInterestadual: 12 },
  { sigla: 'SC', nome: 'Santa Catarina', aliquotaInterestadual: 12 },
  { sigla: 'SP', nome: 'São Paulo', aliquotaInterestadual: 12 },
];

const UF_MAP = Object.fromEntries(UFS_BR.map((u) => [u.sigla, u]));

/** Alíquota interestadual padrão conforme UF de destino (null se mesma UF). */
export function getAliquotaInterestadual(ufOrigem, ufDestino) {
  const o = String(ufOrigem || '').trim().toUpperCase();
  const d = String(ufDestino || '').trim().toUpperCase();
  if (!o || !d || o === d) return null;
  return UF_MAP[d]?.aliquotaInterestadual ?? 12;
}

/** Normaliza CSOSN/CST para comparação no Select (número). */
export function normalizarCsosnValor(raw) {
  if (raw == null || raw === '') return 102;
  const digits = String(raw).replace(/\D/g, '');
  if (!digits) return 102;
  const n = Number(digits);
  return Number.isFinite(n) ? n : 102;
}

export const MOD_BC_ICMS = [
  { value: 0, label: 'Margem valor agregado (%)' },
  { value: 1, label: 'Pauta (valor)' },
  { value: 2, label: 'Preço tabelado máximo' },
  { value: 3, label: 'Valor da operação' },
];

export const MOD_BC_ICMS_ST = [
  { value: 0, label: 'Preço tabelado ou máximo sugerido' },
  { value: 1, label: 'Lista negativa (valor)' },
  { value: 2, label: 'Lista positiva (valor)' },
  { value: 3, label: 'Lista neutra (valor)' },
  { value: 4, label: 'Margem valor agregado (%)' },
  { value: 5, label: 'Pauta (valor)' },
  { value: 6, label: 'Valor da operação' },
];
